import * as React from "react";
const SvgMarkerFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 2a8 8 0 0 1 8 8c0 4.362-2.51 8.308-7.418 11.814a1 1 0 0 1-1.163 0C6.511 18.308 4 14.362 4 10a8 8 0 0 1 8-8m0 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8", clipRule: "evenodd" }));
export default SvgMarkerFill;
